import PropTypes from "prop-types";
import React from "react";
import Chapter from "app/components/Chapter";

export default class RecursiveChapter extends React.Component {
  render() {
    return (
      <Chapter
        {...this.props}
        ref={(c) => {
          if (this.props.passthruRef) {
            this.props.passthruRef(c);
          }
        }}
      />
    );
  }
}
